export default {
  apiKey: "AIzaSyDnfTgj4RSTFTEVqjQOGkr6ikbkmdWAWPo",
  authDomain: "proglib-push.firebaseapp.com",
  databaseURL: "https://proglib-push.firebaseio.com",
  projectId: "proglib-push",
  storageBucket: "",
  messagingSenderId: "183860752308",
  appId: "1:183860752308:web:7f8263571eeb7f38"
};
